module.exports = __webpack_public_path__ + "static/media/1-3_Foiling_01.4d3dd029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/1-3_Foiling_01.jpg
// module id = 1715
// module chunks = 0